<template>
  <div
    v-loading="isLoading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    class="detail-list f-tal">
    <el-timeline>
      <el-timeline-item
        v-for="(item, index) in timeList"
        :key="index"
        :timestamp="item.commentTime"
        placement="top"
        class="f-pr pd-row10 pd-btm30">
        <span :style="{background: item.bgColor}" class="icon-type color-white f-fs1 f-pa">{{ item.commentTag }}</span>
        <div class="f-df f-jcsb f-aib mg-top10">
          <div class="f-lhn" v-html="item.content"></div>
          <span class="color-lighter-gray f-fs1 mg-left20 f-tar" style="min-width: 150px;">{{ item.authName }}</span>
        </div>
        <p class="f-fs1 mg-top10 detail-title color-lighter-gray f-csp" @click="detailItem(item)">原文：{{ item.title || '-' }}</p>
      </el-timeline-item>
      <el-timeline-item
        v-if="timeList.length"
        placement="top"
        class="f-pr pd-row10">
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
export default {
  props: {
    scrollDom: {
      type: String,
      default: '.detail-list'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    timeAllList: {
      type: Array,
      default: () => {
        return []
      }
    },
    timeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mounted() {
    // 监听评论详情滚动事件
    this.$nextTick(() => {
      const _this = this
      document.querySelector(this.scrollDom).onscroll = () => {
        if (_this.$route.name !== 'analysisComment') return
        // 监听滚动元素
        const dom = document.querySelector(this.scrollDom)
        // 元素本身高度
        const clientHeight = dom.offsetHeight // 395
        // 元素内容所有高度
        const hei = document.querySelector(this.scrollDom + ' .el-timeline').offsetHeight
        // 获取滚动高度
        const top = dom.scrollTop
        // 滚动距离底部的距离
        const scrollBottom = hei - clientHeight - top
        // 滚动到底部时，加载数据
        if (scrollBottom < clientHeight && this.timeList.length < this.timeAllList.length) {
          this.timeList = this.timeAllList.slice(0, this.timeList.length + 20)
        }
      }
    })
  },
  methods: {
    // 点击原文链接跳转
    detailItem(item) {
      window.open(item.articleUrl)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.detail-list{
  min-height: 300px;
  max-height: 395px;
  padding: 15px 20px;
  overflow-x: hidden;
  & .detail-title:hover{
    color: #326CFA;
    cursor: pointer;
    text-decoration: underline;
  }
  & .icon-type{
    padding: 1px 6px;
    border-radius: 3px;
    top: 0;
    left: 155px;
  }
}
// /deep/.el-timeline-item__timestamp{
//  width: 105px
// }
</style>
